import entityManager from '../lib/entityManager';
import { TUNE } from '../lib/config';
import { TakesTurns, ActorStats, WantsToAct } from '../components';

export default class TurnSystem {
  update() {
    const entities = entityManager.query([TakesTurns, ActorStats]);

    entities.forEach(entity => {
      // Don't advance turns for entities that are already waiting to act.
      if (entity.hasComponent(WantsToAct)) {
        return;
      }

      const turn = entity.getComponent(TakesTurns);
      const stats = entity.getComponent(ActorStats);

      turn.energy += stats.speed;

      if (turn.energy >= TUNE.ACTION_COST) {
        // This entity is ready for its turn.
        entity.addComponent(WantsToAct);
        // The energy cost is now handled by the ActionSystem when the action is completed.
      }
    });
  }
}
